'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPowerpayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.89168 23.363H4.34483V32.8774H5.92544V29.8195H7.71202C9.69096 29.8195 11.3101 28.7049 11.3101 26.5706V26.5438C11.3101 24.6269 9.99946 23.363 7.89168 23.363ZM9.70385 26.6114C9.70385 27.6037 8.95846 28.3104 7.76348 28.3104H5.92563V24.8855H7.76348C8.94576 24.8855 9.70385 25.4699 9.70385 26.5841V26.6114Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6578 23.363H24.3673L26.5132 30.4173L28.7235 23.3357H30.06L32.2708 30.4173L34.4171 23.363H36.0749L32.9518 32.9455H31.5767L29.3664 26.1086L27.1556 32.9455H25.7937L22.6578 23.363Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M37.6944 23.363H44.3643V24.8582H39.275V27.3316H43.7859V28.8267H39.275V31.3822H44.4283V32.8774H37.6944V23.363Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M50.3139 23.363H46.3043V32.8774H47.8849V29.5613H49.8638L52.0746 32.8774H53.951L51.5216 29.2758C52.7683 28.8953 53.6552 27.9573 53.6552 26.394V26.3672C53.6552 25.5381 53.3853 24.8308 52.9098 24.3145C52.3314 23.7167 51.4449 23.363 50.3139 23.363ZM52.0489 26.4895C52.0489 27.4544 51.3294 28.0796 50.1984 28.0796H47.8851V24.8855H50.1857C51.3548 24.8855 52.0489 25.443 52.0489 26.4622V26.4895Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.1972 24.2373L19.3402 25.4594C19.9604 26.0822 20.4744 27.1244 20.4744 28.1205V28.1473C20.4744 29.9961 19.034 31.6323 17.2474 31.6323C15.4613 31.6323 13.9986 29.9692 13.9986 28.1205V28.0936C13.9986 27.0951 14.4346 26.1407 15.0502 25.5247L14.2822 24.2527C13.1902 25.16 12.531 26.5659 12.531 28.1205V28.1473C12.531 30.8252 14.4586 33.041 17.222 33.041C19.9849 33.041 21.9384 30.7979 21.9384 28.1205V28.0936C21.9384 26.5366 21.286 25.137 20.1972 24.2373Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.9403 27.5509C17.9403 27.9631 17.6246 28.2975 17.2344 28.2975C16.8452 28.2975 16.5289 27.9631 16.5289 27.5509V23.9461C16.5289 23.5339 16.8452 23.2 17.2344 23.2C17.6246 23.2 17.9403 23.5339 17.9403 23.9461V27.5509Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.2824 24.2522C14.5396 23.9801 14.9552 24.0909 15.2519 24.4047C15.5486 24.7185 15.3081 25.2526 15.0504 25.5246C14.7932 25.7967 14.6054 25.6931 14.3087 25.3793C14.012 25.0655 14.0251 24.5242 14.2824 24.2522Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.1973 24.2373C19.9401 23.9653 19.5082 24.0915 19.2114 24.4053C18.9143 24.7191 19.0826 25.1869 19.3403 25.4594C19.5975 25.7319 19.8575 25.6936 20.1542 25.3788C20.4509 25.066 20.4545 24.5089 20.1973 24.2373Z",
          fill: "#DCA126"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.7434 23.2681H55.1971V32.78H56.7777V29.7226H58.5633C60.5423 29.7226 62.161 28.6084 62.161 26.4752V26.4478C62.161 24.5319 60.8503 23.2681 58.7434 23.2681ZM60.5552 26.5155C60.5552 27.5077 59.8098 28.214 58.6148 28.214H56.7778V24.79H58.6148C59.7971 24.79 60.5552 25.3745 60.5552 26.4886V26.5155Z",
          fill: "#467BA8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M67.5335 23.2H66.0686L62.1116 32.78H63.7303L64.6554 30.4836H68.9081L69.8205 32.78H71.4905L67.5335 23.2ZM66.7753 25.1974L68.3301 29.0024H65.2333L66.7753 25.1974Z",
          fill: "#467BA8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M74.2811 29.0297L70.7093 23.2681H72.5848L75.0904 27.467L77.6342 23.2681H79.4462L75.8739 28.9889V32.78H74.2811V29.0297Z",
          fill: "#467BA8"
        }
      )
    ]
  }
);
const VpPaymentPowerpayAsset = forwardRef(PaymentPowerpayAsset);

export { VpPaymentPowerpayAsset as default };
